export default __webpack_public_path__ + "static/media/footerOvl.cdc85b3a.svg";